"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileDevice = exports.MobileDeviceClassName = void 0;
const ModelCommon_1 = require("./ModelCommon");
exports.MobileDeviceClassName = 'MobileDevice';
class MobileDevice extends ModelCommon_1.ModelCommon {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.MobileDeviceClassName)
            throw new Error(`Tried to create a ${exports.MobileDeviceClassName} from a ${ob.type} object!`);
        super(exports.MobileDeviceClassName, ob);
        this.type = ob.type ?? exports.MobileDeviceClassName;
        this.mobileType = ob.mobileType;
        this.operatingSystem = ob.operatingSystem;
        this.brand = ob.brand;
        this.model = ob.model;
        // @ts-expect-error
        this.mobilePushPlatform = ob.mobilePushPlatform;
        this.deviceToken = ob.deviceToken ?? null;
        this.platformEndpointArn = ob.platformEndpointArn ?? null;
        this.isProduction = !!ob.isProduction;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
        };
    }
}
exports.MobileDevice = MobileDevice;
